import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import Swal from 'sweetalert2'


import Prompt from '../../Shared/Prompt/Prompt';
import PromptWrapper from '../../Shared/Prompt/Wrapper';
import PromptActions from '../../Shared/Prompt/Actions';

import { Container } from 'react-smooth-dnd';
import BeatLoader from 'react-spinners/BeatLoader';

import { toast } from 'react-toastify';
import { colors, toastTimerValue } from '../../../Shared/utils';

import { getDeploymentsHistory } from '../../../Functions/reporting';
import { decodeHTMLEntities, compareVersionStrings } from '../../../Functions/utils';

import Deployment from './historyDetails/deploymentsDetail'

import { diag_code_ids } from "../../../Shared/diagcode"

import './historyDetails/historyDetails.css';
import '../../SweetAlert.css'

const line_separator = " / ";
const tab = "       ";
const space = "  ";


const fixAndParse = (inText) => {
  let fixed = inText;

  fixed = fixed.replace(/[^\x20-\x7F]/g, x => "\\u" + ("000" + x.codePointAt(0).toString(16)).slice(-4));

  fixed = fixed.replace(/\\/g, '\\\\');
  fixed = fixed.replace(/\n/g, ' ');
  fixed = fixed.replace(/\r/g, ' ');
  fixed = fixed.replace(/\t/g, '   ');
  fixed = fixed.replace(/&lt;/g, '<');
  fixed = fixed.replace(/&gt;/g, '>');
  fixed = fixed.replace(/&amp;/g, '&');

  try {
    let jsonFixed = JSON.parse(fixed);

    for (const key of Object.keys(jsonFixed)) {
      jsonFixed[key] = jsonFixed[key].replace(/&quot;/g, '\"');
      jsonFixed[key] = jsonFixed[key].replace(/&apos;/g, '\'');

      var r = /\\u([\d\w]{4})/gi;
      jsonFixed[key] = jsonFixed[key].replace(r, function (match, grp) {
        return String.fromCharCode(parseInt(grp, 16));
      });
    }
    return jsonFixed;
  }
  catch (e) {
    console.log("41 - Error=", e, inText, fixed);
  }
  return {};
}


const isNumeric = (value) => {
  return /^-?\d+$/.test(value);
}

const getWifiVersionText = (InText) => {
  /*
          0	unknown
          1	deprecated
          2	deprecated
          3	infrared
          4	Wi-Fi 2 (802.11a)
          5	Wi-Fi 1 (802.11)
          6	Wi-Fi 3 (802.11g)
          7	Wi-Fi 4 (802.11n)
          8	Wi-Fi 5 (802.11ac)
          9	WiGig (802.11ad)
          10	Wi-Fi 6/6E (802.11ax)
          11	Wi-Fi 7 (802.11be)
  */
  switch (InText) {
    case "0": {
      return " - unknown";
    }

    case "1":
    case "2": {
      return " - deprecated";
    }

    case "3": {
      return " - infrared";
    }

    case "4": {
      return " - Wi-Fi 2 (802.11a)";
    }

    case "5": {
      return " - Wi-Fi 1 (802.11)";
    }

    case "6": {
      return " - Wi-Fi 3 (802.11g)";
    }

    case "7": {
      return " - Wi-Fi 4 (802.11n)";
    }

    case "8": {
      return " - Wi-Fi 5 (802.11ac)";
    }

    case "9": {
      return " - WiGig (802.11ad)";
    }

    case "10": {
      return " - Wi-Fi 6/6E (802.11ax)";
    }

    case "11": {
      return " - Wi-Fi 7 (802.11be)";
    }
  }
  return "";
};


const getDiskBus = (InText) => {
  if (parseInt(InText) >= 0 && parseInt(InText) <= 17) {
    const tableDiskBus = ["UNKNOWN", "SCSI", "ATAPI", "ATA", "1394", "SSA", "Fibre Channel", "USB", "RAID", "iSCSI", "SAS", "SATA", "SD", "MMC", "Virtual", "File Backed Virtual", "Storage Spaces", "NVMe"];
    return tableDiskBus.at(parseInt(InText));
  }
  return "";
};

const getSBARActivationResult = (inText) => {
  let outText = '';
  switch (inText) {
    default: {
      outText = inText;
      break;
    }
    case '0x90001000': {
      outText = 'SBAR_NOT_FOUND (' + inText + ')';
      break;
    }
    case '0x90001001': {
      outText = 'SBAR_ACTIVATION_UNKNOWN (' + inText + ')';
      break;
    }
    case '0x90001002': {
      outText = 'SBAR_REACTIVATION_UNKNOWN (' + inText + ')';
      break;
    }
    case '0x90002000': {
      outText = 'SBAR_ALREADY_ACTIVATED_BASIC (' + inText + ')';
      break;
    }
    case '0x90002001': {
      outText = 'SBAR_ALREADY_ACTIVATED_PREMIUM (' + inText + ')';
      break;
    }
    case '0x90002002': {
      outText = 'SBAR_ALREADY_ACTIVATED_ENTERPRISE (' + inText + ')';
      break;
    }
    case '0x90003000': {
      outText = 'SBAR_ACTIVATED_BASIC (' + inText + ')';
      break;
    }
    case '0x90003001': {
      outText = 'SBAR_ACTIVATED_PREMIUM (' + inText + ')';
      break;
    }
    case '0x90003002': {
      outText = 'SBAR_ACTIVATED_ENTERPRISE (' + inText + ')';
      break;
    }
    case '0x90004000': {
      outText = 'SBAR_REACTIVATED_BASIC (' + inText + ')';
      break;
    }
    case '0x90004001': {
      outText = 'SBAR_REACTIVATED_PREMIUM (' + inText + ')';
      break;
    }
    case '0x90004002': {
      outText = 'SBAR_REACTIVATED_ENTERPRISE (' + inText + ')';
      break;
    }
  }
  return outText;
}


const getDiskHealth = (InText) => {
  // const tableDiskHealth = ["UNKNOWN", "GOOD", "BAD", "WARNING"];
  switch (InText) {
    default:
      return {
        text: " ",
        color: "black"
      }

    case "-1":
      return {
        text: "UNKNOWN",
        color: "grey"
      }
      break;

    case "1":
      return {
        text: "GOOD",
        color: "green"
      }
      break;

    case "2":
      return {
        text: "BAD",
        color: "red"
      }
      break;

    case "3":
      return {
        text: "WARNING",
        color: "orange"
      }
      break;
  }
};

const addDataToTmpModule = (moduleHwId, item, tmpModule, mapXtra, tmpDeployment, t, deployment) => {

  // if (item.deployment_id == '4') {
  // console.log("122 - addDataToTmpModule(", moduleHwId, ")");
  // console.log("128 - moduleHwId=", moduleHwId);
  // console.log("129 - item=", item);
  // console.log("130 - tmpModule=", tmpModule);
  // console.log("131 - mapXtra=", mapXtra);
  //   console.log("185 - deployment=", deployment);
  // }

  // /(?<=-).+/gm

  const versionDeployJukebox = tmpDeployment && tmpDeployment.versionDeployJukebox;

  const regex = /(?<=-).+/gm;  // 
  const tmpMatch = item.module_name.match(regex);
  const moduleVersion = tmpMatch && tmpMatch[0]; 

  // console.log("118 - moduleVersion=", moduleVersion);
  let line = {};

  switch (moduleHwId) {
    default: {
      // console.log("117 - MISSING MODULE=", moduleHwId);

      let index = 0;
      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "grey" },
        text: 'TBD Module ' + moduleHwId
      });
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    // HIDDEN MODULES                  
    case 1106:    // MENU
    case 1134:    // SDS KIOSK
    case 1139: {
      // console.log("139 - HIDDEN MODULE=", moduleHwId);

      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Hidden module=' + moduleHwId
      });
      tmpModule.data.push(line);
      tmpModule.visible = false;
      break;
    }


    //-----------------------------------------------------------
    case 1101: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Welcome screen (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        if (key !== 'user_click' && key !== 'exit_code') {
          if (key) {

            line = {
              index: 0,
              data: []
            }

            line.index = ++index;
            line.data.push({
              style: { color: "black" },
              text: tab + key + ': ' + mapXtra.get(key)
            });
            tmpModule.data.push(line);
          }
        }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { color: "green" },
          text: 'User selected ' + mapXtra.get('user_click') + ' (exited with code ' + mapXtra.get('exit_code') + ')'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1103: {
      // console.log("307 - item=", item);
      // console.log("308 - mapXtra=", mapXtra);

      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Summary (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // Bios selected
      if (mapXtra.get('selected_bios')) {
        let strTmp = "";
        strTmp = mapXtra.get('selected_bios');

        if (strTmp && strTmp != '')
          strTmp = strTmp.replaceAll(line_separator, ", ");

        line = {
          index: 0,
          data: []
        }
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: tab + 'Bios selected: ' + strTmp
        });
        tmpModule.data.push(line);
      }

      // Applications selected
      if (mapXtra.get('selected_app')) {
        let strTmp = "";
        strTmp = mapXtra.get('selected_app');

        if (strTmp && strTmp != '')
          strTmp = strTmp.replaceAll(line_separator, ", ");

        line = {
          index: 0,
          data: []
        }
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: tab + 'Applications selected: ' + strTmp
        });
        tmpModule.data.push(line);
      }

      // Drivers selected
      if (mapXtra.get('selected_drv')) {
        let strTmp = "";
        strTmp = mapXtra.get('selected_drv');

        if (strTmp && strTmp != '')
          strTmp = strTmp.replaceAll(line_separator, ", ");

        line = {
          index: 0,
          data: []
        }
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: tab + 'Drivers selected: ' + strTmp
        });
        tmpModule.data.push(line);
      }

      // Bundles selected
      if (mapXtra.get('selected_bdl')) {
        let strTmp = "";
        strTmp = mapXtra.get('selected_bdl');

        if (strTmp && strTmp != '')
          strTmp = strTmp.replaceAll(line_separator, ", ");

        line = {
          index: 0,
          data: []
        }
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: tab + 'Bundles selected: ' + strTmp
        });
        tmpModule.data.push(line);
      }


      // empty line
      // line = {
      //   index: 0,
      //   data: []
      // }
      // line.index = ++index;
      // line.data.push({
      //   style: { color: "black" },
      //   text: " "
      // });
      // tmpModule.data.push(line);

      // // Result                    
      // line = {
      //   index: 0,
      //   data: []
      // };
      // line.index = ++index;
      // line.data.push({
      //   style: { color: "black" },
      //   text: 'Result: '
      // });

      // if (item.closing_code === 0) {
      //   line.data.push({
      //     style: { display: "flex", color: "green" },
      //     text: item.module_result_data
      //   });
      // }
      // else if (item.closing_code === null) {
      //   line.data.push({
      //     style: { display: "flex", color: "orange" },
      //     text: 'INTERRUPTED'
      //   });
      // }
      // else {
      //   line.data.push({
      //     style: { display: "flex", color: "red" },
      //     text: item.module_result_data
      //   });
      // }
      // tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1104: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Image selection (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'Operator selected: ' + mapXtra.get('image_selected') + ' (' + mapXtra.get('os_version') + ')'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'Operator aborted the image selection'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1105: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'SmartImage selection (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
          });
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'Operator aborted the Smart Image selection'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1107: {
      // console.log("451 - item=", item);
      // console.log("452 - mapXtra=", mapXtra);

      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Profile/Preset selection (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);


      if (mapXtra.get('article_code_used')) {
        let strTmp = "";
        strTmp = mapXtra.get('article_code_used');

        if (strTmp && strTmp != '')
          strTmp = strTmp.replaceAll(line_separator, ", ");

        line = {
          index: 0,
          data: []
        }
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: tab + 'Article codes used: ' + strTmp
        });
        tmpModule.data.push(line);
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: item.module_result_data
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: item.module_result_data
        });
      }
      tmpModule.data.push(line);
      break;
    }

    //-----------------------------------------------------------
    case 1108: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Applications selection (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      for (const key of Array.from(mapXtra.keys())) {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' //+ mapXtra.get(key)
          });

          line.data.push({
            style: { color: "black" },
            text: mapXtra.get(key)
          });

          tmpModule.data.push(line);
        }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'Applications selection skipped'
        });
      }
      else if (item.closing_code === 1) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'Application selection done / automatic mode'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      tmpModule.data.push(line);
      break;
    }

    //-----------------------------------------------------------
    case 1109: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Drivers selection (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      for (const key of Array.from(mapXtra.keys())) {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' //+ mapXtra.get(key)
          });

          line.data.push({
            style: { color: "black" },
            text: mapXtra.get(key)
          });

          tmpModule.data.push(line);
        }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });
      line.data.push({
        style: { display: "flex", color: "green" },
        text: 'Exited driver selection'
      });
      tmpModule.data.push(line);
      break;
    }

    //-----------------------------------------------------------
    case 1110: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'BIOS selection (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      for (const key of Array.from(mapXtra.keys())) {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' //+ mapXtra.get(key)
          });

          line.data.push({
            style: { color: "black" },
            text: mapXtra.get(key)
          });

          tmpModule.data.push(line);
        }
      }


      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'BIOS selected'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'No BIOS found / BIOS selection skipped'
        });
      }
      tmpModule.data.push(line);
      break;
    }

    //-----------------------------------------------------------
    case 1111: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Recovery Solution (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 1) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'Clone mode (original OEM Disk topology) selected'
        });
      }
      else if (item.closing_code === 2) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'No recovery solution selected'
        });
      }
      else if (item.closing_code === 3) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'Softthinks recovery solution selected'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'User clicked on Cancel button'
        });
      }
      tmpModule.data.push(line);
      break;
    }

    //-----------------------------------------------------------
    case 1112: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Disk Configuration (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'Disk configuration done'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'Disk configuration aborted'
        });
      }
      tmpModule.data.push(line);
      break;
    }

    //-----------------------------------------------------------
    case 1113: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Command line execution (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: tab + 'Command line to execute: [' + mapXtra.get('launched_cmd') + ']'
      });
      tmpModule.data.push(line);

      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: tab + 'Command line return code: ' + mapXtra.get('process_error_code')
      });
      tmpModule.data.push(line);

      // Extra Line 
      /*if (item.closing_code !== 1000 && item.closing_code !== 1001) {
        line = {
          index: 0,
          data: []
        };
        line.index = ++index;
        line.data.push({
          style: { color: "orange" },
          text: tab + 'Operation aborted'
        });
        tmpModule.data.push(line);
      }*/

      // ONLY FOR  1000 OR 1001     
      if (item.closing_code === 1000 || item.closing_code === 1001) {

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 1000) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED'
        });
      }
      else if (item.closing_code === 1001) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED'
        });
      }
        // else if (item.closing_code === 0) {
        //   line.data.push({
        //     style: { display: "flex", color: "green" },
        //     text: 'PASSED'
        //   });
        // }
        // else if (item.closing_code === null) {
        //   line.data.push({
        //     style: { display: "flex", color: "orange" },
        //     text: 'INTERRUPTED'
        //   });
        // }
        // else {
        //   line.data.push({
        //     style: { display: "flex", color: "red" },
        //     text: 'FAILED'
        //   });
        // }
      tmpModule.data.push(line);
      }
      break;
    }


    //-----------------------------------------------------------
    case 1114: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Smart Repair (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'NO ISSUE FOUND'
        });
      }
      else if (item.closing_code === 1) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'ISSUE FOUND (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === 2) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'ISSUE FOUND AND NOT FIXED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === 3) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'Canceled by the user'
        });
      }
      else if (item.closing_code === 4) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'ISSUE FOUND AND FIXED'
        });
      }
      else if (item.closing_code === 5) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (Fatal error)'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED (Reboot)'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1115: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Image extraction (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
          });
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === 1) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED'
        });
      }
      else if (item.closing_code === 2) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code == '0xF004UL') {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code == '0xF005UL') {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1116: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'OS Configuration (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' //+ mapXtra.get(key)
          });

          if (mapXtra.get(key).toUpperCase() === "SUCCESS") {
            line.data.push({
              style: { color: "green" },
              text: mapXtra.get(key)
            });
          }
          else {
            line.data.push({
              style: { color: "red" },
              text: mapXtra.get(key)
            });
          }
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code !== 1) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED (' + item.module_result_data + ')'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1117: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'System Diagnostic & Repair (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' //+ mapXtra.get(key)
          });

          if (mapXtra.get(key).toUpperCase() === "SUCCESS") {
            line.data.push({
              style: { color: "green" },
              text: mapXtra.get(key)
            });
          }
          else {
            line.data.push({
              style: { color: "red" },
              text: mapXtra.get(key)
            });
          }
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code !== 0) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED (' + item.module_result_data + ')'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1118: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Update (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      // line = {
      //   index: 0,
      //   data: []
      // };
      // line.index = ++index;
      // line.data.push({
      //   style: { color: "black" },
      //   text: 'TO BE SPECIFIED'
      // });
      // tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1119: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Process completion (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // Extra Line 
      if (mapXtra.get('message_level_0')) {
        let xtralines = String(mapXtra.get('message_level_0')).split(line_separator);

        xtralines.map(xtraline => {
        line = {
          index: 0,
          data: []
        };
        line.index = ++index;
        line.data.push({
          style: { color: "red" },
            text: tab + xtraline
        });
        tmpModule.data.push(line);
        })
      }
      else if (mapXtra.get('message_level_1')) {
        let xtralines = String(mapXtra.get('message_level_1')).split(line_separator);

        xtralines.map(xtraline => {
        line = {
          index: 0,
          data: []
        };
        line.index = ++index;
        line.data.push({
          style: { color: "orange" },
            text: tab + xtraline
        });
        tmpModule.data.push(line);
        })
      }
      else if (mapXtra.get('message_level_2')) {
        let xtralines = String(mapXtra.get('message_level_2')).split(line_separator);

        xtralines.map(xtraline => {
        line = {
          index: 0,
          data: []
        };
        line.index = ++index;
        line.data.push({
          style: { color: "green" },
            text: tab + xtraline
        });
        tmpModule.data.push(line);
        })
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: tab + 'Global process result: ' + mapXtra.get('deploy_status')
      });
      tmpModule.data.push(line);

      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: tab + 'Global process duration: ' + mapXtra.get('deploy_duration')
      });
      tmpModule.data.push(line);

      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      if (item.closing_code === 61444) {
        line.data.push({
          style: { display: "flex", color: "black" },
          text: tab + 'The device has been rebooted'
        });
        tmpModule.data.push(line);
      }
      else if (item.closing_code === 61445) {
        line.data.push({
          style: { display: "flex", color: "black" },
          text: tab + 'The device has been shutdown'
        });
        tmpModule.data.push(line);
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      break;
    }


    //-----------------------------------------------------------
    case 1120: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Process completion (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
          });
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED'
        });
      }
      else if (item.closing_code === 61445) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      tmpModule.data.push(line);
      break;
    }

    //-----------------------------------------------------------
    case 1123: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Image capture (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
          });
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (' + item.closing_code + ' - ' + item.module_result_data + ')'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1125: {
      if (item.module_param1 === '32768') {
        // Header
        let index = 0;

        // New Line
        line = {
          index: index,
          data: []
        }
        line.data.push({
          style: { color: "black", fontSize: '150%', textDecoration: "underline" },
          text: 'SBAR Reactivation (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
        });
        tmpModule.data.push(line);

        // List                    
        for (const key of Array.from(mapXtra.keys())) {
          // if (key !== 'user_click' && key !== 'exit_code') {
          if (key) {

            line = {
              index: 0,
              data: []
            }
            line.index = ++index;

            if (key === 'SBAR_activation_result') {
              line.data.push({
                style: { color: "black" },
                text: tab + key.replaceAll("_", " ") + ': ' + getSBARActivationResult(mapXtra.get(key))
              });
            }
            else {
              line.data.push({
                style: { color: "black" },
                text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
              });
            }
            tmpModule.data.push(line);
          }
          // }
        }

        // empty line
        line = {
          index: 0,
          data: []
        }
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: " "
        });
        tmpModule.data.push(line);

        // Result                    
        line = {
          index: 0,
          data: []
        };
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: 'Result: '
        });

        if (item.closing_code === 0) {
          line.data.push({
            style: { display: "flex", color: "green" },
            text: 'PASSED'
          });
        }
        else if (item.closing_code === null) {
          line.data.push({
            style: { display: "flex", color: "orange" },
            text: 'INTERRUPTED'
          });
        }
        else {
          line.data.push({
            style: { display: "flex", color: "red" },
            text: 'FAILED TO REACTIVATE SBAR (' + item.closing_code + ' - ' + item.module_result_data + ')'
          });
        }
        tmpModule.data.push(line);
      }
      else if (item.module_param1 === '16384') {
        // Header
        let index = 0;

        // New Line
        line = {
          index: index,
          data: []
        }
        line.data.push({
          style: { color: "black", fontSize: '150%', textDecoration: "underline" },
          text: 'SBAR Installation & Activation (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
        });
        tmpModule.data.push(line);


        // List                    
        for (const key of Array.from(mapXtra.keys())) {
          // if (key !== 'user_click' && key !== 'exit_code') {
          if (key) {

            line = {
              index: 0,
              data: []
            }
            line.index = ++index;

            if (key === 'SBAR_activation_result') {
              line.data.push({
                style: { color: "black" },
                text: tab + key.replaceAll("_", " ") + ': ' + getSBARActivationResult(mapXtra.get(key))
              });
            }
            else {
              line.data.push({
                style: { color: "black" },
                text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
              });
            }
            tmpModule.data.push(line);
          }
          // }
        }

        // empty line
        line = {
          index: 0,
          data: []
        }
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: " "
        });
        tmpModule.data.push(line);

        // Result                    
        line = {
          index: 0,
          data: []
        };
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: 'Result: '
        });

        if (item.closing_code === 0) {
          line.data.push({
            style: { display: "flex", color: "green" },
            text: 'PASSED (SBAR installed and activated)'
          });
        }
        else if (item.closing_code === 14) {
          line.data.push({
            style: { display: "flex", color: "red" },
            text: 'FAILED TO INSTALL SBAR'
          });
        }
        else if (item.closing_code === 15) {
          line.data.push({
            style: { display: "flex", color: "red" },
            text: 'FAILED TO ACTIVATE SBAR'
          });
        }
        else if (item.closing_code === null) {
          line.data.push({
            style: { display: "flex", color: "orange" },
            text: 'INTERRUPTED'
          });
        }
        else {
          line.data.push({
            style: { display: "flex", color: "red" },
            text: 'FAILED'
          });
        }
        tmpModule.data.push(line);
      }
      else {
        // Header
        let index = 0;

        // New Line
        line = {
          index: index,
          data: []
        }
        line.data.push({
          style: { color: "black", fontSize: '150%', textDecoration: "underline" },
          text: 'Copy (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
        });
        tmpModule.data.push(line);

        // List                    
        for (const key of Array.from(mapXtra.keys())) {
          // if (key !== 'user_click' && key !== 'exit_code') {
          if (key) {

            line = {
              index: 0,
              data: []
            }
            line.index = ++index;

            if (key === 'SBAR_activation_result') {
              line.data.push({
                style: { color: "black" },
                text: tab + key.replaceAll("_", " ") + ': ' + getSBARActivationResult(mapXtra.get(key))
              });
            }
            else {
              line.data.push({
                style: { color: "black" },
                text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
              });
            }
            tmpModule.data.push(line);
          }
          // }
        }

        // empty line
        line = {
          index: 0,
          data: []
        }
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: " "
        });
        tmpModule.data.push(line);

        // Result                    
        line = {
          index: 0,
          data: []
        };
        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: 'Result: '
        });

        if (item.closing_code === 0) {
          line.data.push({
            style: { display: "flex", color: "green" },
            text: 'PASSED'
          });
        }
        else if (item.closing_code === null) {
          line.data.push({
            style: { display: "flex", color: "orange" },
            text: 'INTERRUPTED'
          });
        }
        else {
          line.data.push({
            style: { display: "flex", color: "red" },
            text: 'FAILED (' + item.closing_code + ' - ' + item.module_result_data + ')'
          });
        }
        tmpModule.data.push(line);
      }
      break;
    }


    //-----------------------------------------------------------
    case 1126: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Wipe (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List FROM WIPED
      // const wipedList = item.wiped_data && item.wiped_data.substring("&lt;wiped&gt;".length - 1).split('&lt;wiped&gt;');
      const wipedList = item.wiped_data && item.wiped_data.split('<wiped>');

      // console.log("2190 - wipedList=", wipedList);
      if (wipedList) {
        for (const wipe of wipedList) {

          const wipeData = fixAndParse(wipe);
          // console.log("2197 - wipeData=", wipeData);

          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab +
              (wipeData.size_commercial).replace(/\s/g, '') + space +
              (wipeData.disk_type ? wipeData.disk_type : '') +
              (wipeData.disk_rpm && wipeData.disk_rpm > 1 ? '(' + wipeData.disk_rpm + 'RPM)' + space : '') +
              (wipeData.disk_formfactor && wipeData.disk_formfactor != "n/a" ? (wipeData.disk_formfactor).replace(/ inches/g, '"') + space : '') +
              wipeData.disk_bus + space +
              wipeData.manufacturer + space + wipeData.model + space + wipeData.serial 
          });
          tmpModule.data.push(line);


          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab +              
              (wipeData.disk_ppid ? t('history.details.ppid') + t('global.colon') + wipeData.disk_ppid + space + "-" + space : t('history.details.ppid') + t('global.colon') + '(NO PPID)' + space + "-" + space) +
              (wipeData.bps ? wipeData.bps + t('history.details.bps') + space + "-" + space : '') +
              (wipeData.disk_path ? wipeData.disk_path : '')
          });
          tmpModule.data.push(line);


          const extraDiskHealthList = deployment.extraDiskHealth && deployment.extraDiskHealth.split("<ext_disk>");
          if (extraDiskHealthList) {
            extraDiskHealthList.forEach(extraDiskHealth => {
              const extraDiskHealthData = fixAndParse(extraDiskHealth);

              const regex = /(?<=ext_disk_health\[)[^\]]*(?=\])/i;
              const items = extraDiskHealthData.xtra_desc.match(regex);

              if (items && items[0] && items[0] == wipeData.serial) {

                line = {
                  index: 0,
                  data: []
                }
                line.index = ++index;
                line.data.push({
                  style: { color: "black" },
                  text: tab +
                    t('history.details.computed_health') + t('global.colon')
                });
                line.data.push({
                  style: { color: "black" },
                  text: extraDiskHealthData.xtra_value + " %"
                });
                tmpModule.data.push(line);
              }
            });
          }

          const extraDiskPerfList = deployment.extraDiskPerf && deployment.extraDiskPerf.split("<ext_disk>");
          if (extraDiskPerfList) {
            extraDiskPerfList.forEach(extraDiskPerf => {
              const extraDiskPerfData = fixAndParse(extraDiskPerf);

              const regex = /(?<=ext_disk_perf\[)[^\]]*(?=\])/i;
              const items = extraDiskPerfData.xtra_desc.match(regex);

              if (items && items[0] && items[0] == wipeData.serial) {

                line = {
                  index: 0,
                  data: []
                }
                line.index = ++index;
                line.data.push({
                  style: { color: "black" },
                  text: tab +
                    t('history.details.computed_perf') + t('global.colon')
                });
                line.data.push({
                  style: { color: "black" },
                  text: extraDiskPerfData.xtra_value + " %"
                });
                tmpModule.data.push(line);
              }
            });
          }


          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab +              
              (wipeData.customer_data ? t('history.details.customer_data') + t('global.colon') + wipeData.customer_data + space : '') +
              t('history.details.health') + t('global.colon')
          });
          line.data.push({
            style: { color: ((getDiskHealth(wipeData.health).color !== "") ? getDiskHealth(wipeData.health).color : "black") },
            text: t('history.details.' + getDiskHealth(wipeData.health).text)
          });
          line.data.push({
            style: { color: "black" },
            text: tab +
              (wipeData.used_percentage ? wipeData.used_percentage : '')
          });
          tmpModule.data.push(line);


          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab +
              t('history.details.reallocated_sectors') + t('global.colon') + wipeData.reallocated_sectors + space + "-" + space +
              t('history.details.power_on_hours') + t('global.colon') + wipeData.power_on_hours + space + "-" + space +
              t('history.details.reported_uncorrectable_errors') + t('global.colon') + wipeData.reported_uncorrectable_errors
          });
          tmpModule.data.push(line);


          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab +
              t('history.details.command_timeout') + t('global.colon') + wipeData.command_timeout + space + "-" + space +
              t('history.details.current_pending_sector_count') + t('global.colon') + wipeData.current_pending_sector_count + space + "-" + space +
              t('history.details.offline_uncorrectable') + t('global.colon') + wipeData.offline_uncorrectable
          });
          tmpModule.data.push(line);


          if (wipeData.disk_orderLot) {
            const regex = /^([A-Za-z]+)_([A-Za-z]+)$/im;  // 
            const orderLot = wipeData.disk_orderLot.match(regex);

            console.log("2347 - wipeData.disk_orderLot=", wipeData.disk_orderLot);
            console.log("2348 - orderLot=", orderLot);

            if (orderLot && orderLot[1] && orderLot[2]) {
          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
              line.data.push({
                style: { color: "black" },
                text: tab +
                  (
                    wipeData.disk_orderLot ?
                      t('history.details.order') + t('global.colon') + orderLot[1] + space + "-" + space +
                      t('history.details.lot') + t('global.colon') + orderLot[2]
                      : ''
                  )
              });

              tmpModule.data.push(line);
            }
          }

          /*
          <string ID="IDS_WIPE_RESULT">
          <nl-NL>Wis resultaat</nl-NL>
          <en-US>Wipe result</en-US>
          <fr-FR>Résultat effacement</fr-FR>
          </string>
          */
          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
          line.data.push({
            style: { fontWeight: "bold" },
            text: t('history.details.wipe_result') + t('global.colon')
          });
          if (wipeData.result === "OK") {
            line.data.push({
              style: { color: "green" },
              text: space + 'Wiped successfully with the algorithm ' + wipeData.algorithm + (wipeData.eraser_rounds !== "*" ? ' (' + wipeData.eraser_rounds + ') in ' + wipeData.time : "")
            });
          }
          else if (wipeData.result === "SMART THRESHOLD OK") {
            line.data.push({
              style: { color: "green" },
              text: space + 'Disk diagnosed only (NOT ERASED)'
            });
          }
          else {
            line.data.push({
              style: { color: "red" },
              text: space + 'Failed to be wiped with the algorithm ' + wipeData.algorithm + (wipeData.eraser_rounds !== "*" ? ' (' + wipeData.eraser_rounds + ') in ' + wipeData.time : "")
            });
          }
          tmpModule.data.push(line);


          // empty line
          line = {
            index: 0,
            data: []
          }
          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: " "
          });
          tmpModule.data.push(line);
        }
      }

      // empty line   
      // line = {
      //   index: 0,
      //   data: []
      // }
      // line.index = ++index;
      // line.data.push({
      //   style: { color: "black" },
      //   text: " "
      // });
      // tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED'
        });
      }
      else if (item.closing_code === 1) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'ABORTED by the user'
        });
      }
      else if (item.closing_code === 2) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (Volume to wipe not present)'
        });
      }
      else if (item.closing_code === 3) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (Disk to wipe not present)'
        });
      }
      else if (item.closing_code === 4) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (Volume to wipe could not be used)'
        });
      }
      else if (item.closing_code === 5) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (No disk found)'
        });
      }
      else if (item.closing_code === 6) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (Disk to wipe could not be used)'
        });
      }
      else if (item.closing_code === 7) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (Read/Write error)'
        });
      }
      else if (item.closing_code === 8) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'SKIPPED by the user'
        });
      }
      else if (item.closing_code === 9) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (thumbprint error)'
        });
      }
      else if (item.closing_code === 10) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (format error)'
        });
      }
      else if (item.closing_code === 11) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (crash)'
        });
      }
      else if (item.closing_code === 12) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (user manually failed the operation)'
        });
      }
      else if (item.closing_code === 13) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (SMART attribute(s) exceeded)'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      // else {
      //   line.data.push({
      //     style: { display: "flex", color: "orange" },
      //     text: 'UNKNOWN ' + item.closing_code
      //   });
      // }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1130: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Data Backup / Migration (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
          });
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED'
        });
      }
      else if (item.closing_code === 2) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'ABORTED by the operator'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (' + item.closing_code + ' - ' + item.module_result_data + ')'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1131: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Standalone disk diagnostic (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
          });
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (' + item.closing_code + ' - ' + item.module_result_data + ')'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1136: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Diagnostics (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List FROM TEST
      // const testsList = item.tests_data && item.tests_data.substring("&lt;tests&gt;".length - 1).split('&lt;tests&gt;');
      const testsList = item.tests_data && item.tests_data.split('<tests>');
      if (testsList) {
        // console.log("2359 - item.tests_data=", item.tests_data);
        // console.log("2361 - tmpModule=", tmpModule);

        for (const test of testsList) {
          const testData = fixAndParse(test);

          // console.log("-----------------------------");
          // console.log("2364 - testData=", testData);
          if (
            compareVersionStrings(versionDeployJukebox, "2.0.5.65") >= 0 && (
            new Date(tmpModule.start_date) > new Date(testData.test_timestamp) ||
            new Date(testData.test_timestamp) > new Date(tmpModule.end_date)
            )
          ) {
            // console.log("2366 - new Date(tmpModule.start_date)=", new Date(tmpModule.start_date));
            // console.log("2366 - new Date(tmpModule.end_date)=", new Date(tmpModule.end_date));
            // console.log("2367 - test.test_timestamp=", new Date(testData.test_timestamp));

            // console.log("2373 - NO IN MODULE TIMES ", testData, versionDeployJukebox);
            continue;
          }
          
          // console.log("2385 - diag_code_ids=", diag_code_ids);
          const found = diag_code_ids.find(element => {
            // console.log("2386 - element=", element);

            return element.id === testData.test_id
          });


          if (found) {
            // console.log("2388 - found=", found);
            line = {
              index: 0,
              data: []
            }
            line.index = ++index;
            line.data.push({
              style: { color: "black" },
              text: tab + t(`reporting.columns.${found.category}.${found.test}`) + ': '
            });

            if (testData.test_result === "0") {
              line.data.push({
                style: { color: "green" },
                text: 'PASSED ' + (testData.test_skipped_reason && testData.test_skipped_reason !== "0" ? t(`skip_reason.${testData.test_skipped_reason}`) : '') + (testData.test_comment ? ' (' + testData.test_comment + ')' : '') + (testData.test_subdevice_sn ? ' - Sub-device id:' + testData.test_subdevice_sn + '' : '') + (testData.test_driver ? ' - Driver:' + testData.test_driver + '' : '')
              });
            }
            else if (testData.test_result === "1") {
              line.data.push({
                style: { color: "red" },
                text: 'FAILED ' + (testData.test_skipped_reason ? t(`skip_reason.${testData.test_skipped_reason}`) : '') + (testData.test_comment ? ' (' + testData.test_comment + ')' : '') + (testData.test_driver ? ' (' + testData.test_driver + ')' : '')
              });
            }
            else if (testData.test_result === "2") {
              line.data.push({
                style: { color: "orange" },
                text: 'WARNING ' + (testData.test_skipped_reason ? t(`skip_reason.${testData.test_skipped_reason}`) : '') + (testData.test_comment ? ' (' + testData.test_comment + ')' : '') + (testData.test_driver ? ' (' + testData.test_driver + ')' : '')
              });
            }
            tmpModule.data.push(line);
          }
        }
      }

      // console.log("2421 - tmpModule=", tmpModule);

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED'
        });
      }
      else if (item.closing_code === 1) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'CANCELED'
        });
      }
      else if (item.closing_code === 2) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'WARNING'
        });
      }
      else if (item.closing_code === 3) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED'
        });
      }
      else if (item.closing_code === -2) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else if (item.closing_code === -666) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'FAILED TO INITIALIZE'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1137: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Trade-in code generation (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
          });
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === null) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED (' + item.module_result_data + ')'
        });
      }
      tmpModule.data.push(line);
      break;
    }


    //-----------------------------------------------------------
    case 1140: {
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Manual inputs (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);

      // List                    
      for (const key of Array.from(mapXtra.keys())) {
        // if (key !== 'user_click' && key !== 'exit_code') {
        if (key) {

          line = {
            index: 0,
            data: []
          }

          line.index = ++index;
          line.data.push({
            style: { color: "black" },
            text: tab + key.replaceAll("_", " ") + ': ' + mapXtra.get(key)
          });
          tmpModule.data.push(line);
        }
        // }
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      if (item.closing_code === null) {
        line = {
          index: 0,
          data: []
        };
        line.index = ++index;
        // line.data.push({
        //   style: { color: "black" },
        //   text: 'Result: '
        // });

        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'INTERRUPTED'
        });
        tmpModule.data.push(line);
      }

      break;
    }

    //-----------------------------------------------------------
    case 1141: {

      // console.log("2545 - item=", item);
      // Header
      let index = 0;

      // New Line
      line = {
        index: index,
        data: []
      }
      line.data.push({
        style: { color: "black", fontSize: '150%', textDecoration: "underline" },
        text: 'Hexadecimal viewer (Param1=' + item.module_param1 + ' / Param2=' + item.module_param2 + (moduleVersion ? ' / v' + moduleVersion : '') + ')'
      });
      tmpModule.data.push(line);


      const mapChecked = new Map();
      const mapAttibuts = new Map();

      for (const key of Array.from(mapXtra.keys())) {
        if (key) {
          if (key.substring(0, 13) === "disk_checked_") {
            const regex = /(?:Disk ID: )([0-9]+)(?: - Model:)/i;  // 
            const items = mapXtra.get(key).match(regex);

            if (items)
              mapChecked.set(items[1], mapXtra.get(key))

          } else if (key.substring(0, 15) === "disk_attributs_") {
            const regex = /(?:Disk ID: )([0-9]+)(?:[|])([0-9]+)(?:[|])(?:.+)/i;  // 
            const items = mapXtra.get(key).match(regex);

            if (items)
              mapAttibuts.set(items[1], items[2])
          }
        }
      }

      for (const key of Array.from(mapChecked.keys())) {
        line = {
          index: 0,
          data: []
        }

        line.index = ++index;
        line.data.push({
          style: { color: "black" },
          text: tab + mapChecked.get(key) + ' : '
        });

        const attribut = mapAttibuts.get(key);
        if (attribut === "0") {
          line.data.push({
            style: { color: "red" },
            text: 'FAILED'
          });
        }
        else if (attribut === "1") {
          line.data.push({
            style: { color: "green" },
            text: 'PASSED'
          });
        }
        tmpModule.data.push(line);
      }

      // empty line
      line = {
        index: 0,
        data: []
      }
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: " "
      });
      tmpModule.data.push(line);

      // Result                    
      line = {
        index: 0,
        data: []
      };
      line.index = ++index;
      line.data.push({
        style: { color: "black" },
        text: 'Result: '
      });

      if (item.closing_code === 0) {
        line.data.push({
          style: { display: "flex", color: "green" },
          text: 'PASSED'// (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === 1) {
        line.data.push({
          style: { display: "flex", color: "orange" },
          text: 'CANCELED'// (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === 2) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED'// (' + item.module_result_data + ')'
        });
      }
      else if (item.closing_code === 3) {
        line.data.push({
          style: { display: "flex", color: "red" },
          text: 'FAILED'// (' + item.module_result_data + ')'
        });
      }
      else {
        line.data.push({
          style: { display: "flex", color: "grey" },
          text: 'UNKNOWN'// (' + item.module_result_data + ')'
        });
      }
      tmpModule.data.push(line);
      break;
    }
  }
  return tmpModule;
}


export default function HistoryDetails({ deployment, setDeployment }) {
  const { t } = useTranslation();

  const defaultExpanded = [];
  defaultExpanded.push("" + deployment.deployment_id)
  const [expanded, setExpanded] = useState(defaultExpanded);

  const [expandedHardwareDetail, setExpandedHardwareDetail] = useState(true);
  const [deployments, setDeployments] = useState([]);
  const [loaded, setLoaded] = useState(deployments && deployments.length > 0);


  const toggleAll = () => (
    setExpanded(expanded.length === deployments.length ? [] : deployments.map(s => s.deployment_id))
  );

  /*
      {
      "deployment_id": "3",
      "date": "2022-09-20T10:54:42.000Z",
      "serial": "7N3LFY1",
      "module_id": 101,
      "module_id_xtra": "13",
      "start_date": "2022-09-20T12:54:42.000Z",
      "end_date": "2022-09-20T12:54:51.000Z",
      "module_name": "SDSWelcome-1.0.0.63",
      "closing_code": 8,
      "module_result_data": null,
      "module_param1": "0",
      "module_param2": "0",
      "module_hwid": 1101,
      "xtra_desc": "id",
      "xtra_value": "a",
      "location": "internalv2_yannickv14",
      "location_id": 12899
    }
  */

  useEffect(() => {
    // console.log("2587 - useEffect... t, deployment, deployments, setDeployments, setLoaded");

    // document.title = t('scenarios.title');
    // console.log("2001 - deployment=", deployment);
    // console.log("3059 - deployments=", deployments);

    if (deployments.length === 0 && deployment.system_serial) {

      getDeploymentsHistory(deployment, 1).then(res => {
        if (!res.success) {
          toast(decodeHTMLEntities(t('scenarios.errors.' + res)), { type: 'error' });

          // Swal.fire({
          //   toast: true,
          //   icon: 'error',
          //   title: t('scenarios.errors.' + res), 
          //   animation: true,
          //   position: 'top-right',
          //   showConfirmButton: false,
          //   timer: toastTimerValue,
          //   timerProgressBar: true,
          //   iconColor: 'white',
          //   customClass: {
          //     popup: 'colored-toast',
          //   },
          //   didOpen: (toast) => {
          //     toast.addEventListener('mouseenter', Swal.stopTimer)
          //     toast.addEventListener('mouseleave', Swal.resumeTimer)
          //     toast.addEventListener('click', Swal.close)
          //   }
          // });

        } else {

          // console.log('2894 - res.deployments=', res.deployments);

          const tmpDeployments = [];
          let tmpDeployment = {
            id: null,
            date: null,
            moduleBootImg: {},
            modules: [],
            versionDeployJukebox: '',
            versionSelector: '',
            lock_bios_admin_password: deployment.lock_bios_admin_password,
            lock_bios_computrace_status: deployment.lock_bios_computrace_status
          }

          let currentDeployment = null;
          let currentModule = null;
          let currentModuleIdXtra = null;
          let previousItem = null;

          // let tmpModules = new Array();
          let tmpModule = {};
          let mapXtra = new Map();

          const len = res.deployments.length;
          let i = 0;

          //for (const item of res.deployments) {
          while (i < len) {
            const item =  res.deployments[i];

            //const nextItem = (i+1) < len ?
            if (currentDeployment !== item.deployment_id) {

              if (tmpModule && tmpModule.module_id) {

                // console.log("------------");
                // console.log("2871 - tmpDeployment=", tmpDeployment);
                tmpModule = addDataToTmpModule(currentModule, previousItem, tmpModule, mapXtra, tmpDeployment, t, deployment);
                tmpDeployment.modules.push(tmpModule)

                currentModule = null;
                tmpModule = {};
                mapXtra = new Map();
              }

              if (tmpDeployment && tmpDeployment.deployment_id) {
                tmpDeployments.push(tmpDeployment);
                tmpDeployment = {};
              }

              tmpDeployment.deployment_id = item.deployment_id;
              tmpDeployment.date = item.date;
              tmpDeployment.moduleBootImg = {};
              tmpDeployment.modules = [];
              tmpDeployment.versionDeployJukebox = '';

              tmpModule = {
                visible: true,
                module_id: item.module_id,
                module_hwid: item.module_hwid,
                module_name: item.module_name,
                start_date: item.start_date,
                end_date: item.end_date,
                data: []
              };

              currentModule = item.module_hwid;
              currentDeployment = item.deployment_id;
              previousItem = item;
            }
            //else if (currentModule !== item.module_hwid) {
            else if (currentModuleIdXtra !== item.module_id_xtra) {

              if (tmpModule && tmpModule.module_id) {
                // console.log("------------");
                // console.log("2915 - tmpDeployment=", tmpDeployment);
                tmpModule = addDataToTmpModule(currentModule, previousItem, tmpModule, mapXtra, tmpDeployment, t, deployment);
                tmpDeployment.modules.push(tmpModule)

                currentModule = null;
                tmpModule = {};
                mapXtra = new Map();
              }

              tmpModule = {
                visible: true,
                module_id: item.module_id,
                module_hwid: item.module_hwid,
                module_name: item.module_name,
                start_date: item.start_date,
                end_date: item.end_date,
                data: []
              };

              currentModule = item.module_hwid;
              currentModuleIdXtra = item.module_id_xtra;
            }

            if (item.module_name === 'Script' && item.module_result === 'DEPLOYJUKEBOX_VERSION') {
              tmpDeployment.versionDeployJukebox = item.module_result_data;
            }

            // console.log('2900 - item.module_name=', item.module_name);
            if (item.module_name === 'WinPE') {
              if (item.module_result === 'BOOT_IMG_CURRENT_NAME')
                tmpDeployment.moduleBootImg.current_name = item.module_result_data;
              else if (item.module_result === 'BOOT_IMG_ORIGINAL_NAME')
                tmpDeployment.moduleBootImg.original_name = item.module_result_data;
              else if (item.module_result === 'BOOT_IMG_DATE')
                tmpDeployment.moduleBootImg.date = item.module_result_data;
              else if (item.module_result === 'BOOT_IMG_WINPE_VER')
                tmpDeployment.moduleBootImg.winpe_ver = item.module_result_data;
              else if (item.module_result === 'BOOT_IMG_LAUNCHER_VER')
                tmpDeployment.moduleBootImg.launcher_ver = item.module_result_data;
              else if (item.module_result === 'BOOT_IMG_BOOT_TYPE')
                tmpDeployment.moduleBootImg.boot_type = item.module_result_data;
              else if (item.module_result === 'BOOT_IMG_SECURE_BOOT')
                tmpDeployment.moduleBootImg.secure_boot = item.module_result_data;
              else if (item.module_result === 'BOOT_IMG_T2_SECURITY')
                tmpDeployment.moduleBootImg.t2_security = item.module_result_data;
            }

            if (item.module_hwid === 1141) { // "disk_checked" === item.xtra_desc ) {

              if (item.xtra_desc === 'disk_checked') {

                const regex = /(?:Disk ID: )([0-9]+)(?: - Model:)/i;  // 
                const items = item.xtra_value.match(regex);

                if (items) {
                  const newXtra_desc = item.xtra_desc + '_' + items[1];
                  mapXtra.set(newXtra_desc, item.xtra_value);
                }
              }
              else if (item.xtra_desc === 'disk_attributs') {

                const regex = /(?:Disk ID: )([0-9]+)(?:[|])([0-9]+)(?:[|])(?:.+)/i;  // 
                const items = item.xtra_value.match(regex);

                if (items) {
                  const newXtra_desc = item.xtra_desc + '_' + items[1];
                  mapXtra.set(newXtra_desc, item.xtra_value);
                }
              }
            }
            else {
              const prev = mapXtra.get(item.xtra_desc);
              if (prev === undefined)
            mapXtra.set(item.xtra_desc, item.xtra_value);
              else
                mapXtra.set(item.xtra_desc, prev + line_separator + item.xtra_value);
            }
            previousItem = item;

            i++;
          }

          if (tmpModule && tmpModule.module_id) {
            // console.log("------------");
            // console.log("2975 - tmpDeployment=", tmpDeployment);
            const newModule = addDataToTmpModule(currentModule, previousItem, tmpModule, mapXtra, tmpDeployment, t, deployment);
            tmpDeployment.modules.push(newModule)
          }

          if (tmpDeployment && tmpDeployment.deployment_id) {
            tmpDeployments.push(tmpDeployment);
          }

          setDeployments(tmpDeployments);
        }
        setLoaded(true);
      });
    }
  }, [t, deployment, deployments, setDeployments, setLoaded]);


  // console.log("15 - deployment=", deployment);

  const biosTxt = deployment.bios_vendor + " " + deployment.bios_version;
  const motherboardTxt = deployment.motherboard_manufacturer + " " + deployment.motherboard_model;


  // // CPU
  let arrayCpu = [];
  if (deployment.cpu_data) {
    const cpuList = deployment.cpu_data.split('<cpu>');

    cpuList.forEach(cpu => {
      const cpuData = fixAndParse(cpu);
      arrayCpu.push(cpuData);
    });
  }
  else if (deployment.cpu_text) {
    const cpuList = deployment.cpu_text.substring("&lt;cpu&gt;".length - 1).split('&lt;cpu&gt;');

    cpuList.forEach(cpu => {
      const cpuData = fixAndParse(cpu);
      arrayCpu.push(cpuData);
    });
  }


  // // GPU
  let arrayGpu = [];
  if (deployment.gpu_data) {
    // const gpuList = deployment.gpu_data.substring("&lt;gpu&gt;".length - 1).split('&lt;gpu&gt;');
    const gpuList = deployment.gpu_data.split('<gpu>');

    gpuList.forEach(gpu => {
      const gpuData = fixAndParse(gpu);
      arrayGpu.push(gpuData);
    });
  }
  else if (deployment.gpu_text) {
    const gpuList = deployment.gpu_text.substring("&lt;gpu&gt;".length - 1).split('&lt;gpu&gt;');
    //const gpuList = deployment.gpu_text.split('<gpu>');

    gpuList.forEach(gpu => {
      const gpuData = fixAndParse(gpu);
      arrayGpu.push(gpuData);
    });
  }


  // // RAM
  let arrayRam = [];
  let cumulRamMb = 0;
  if (deployment.ram_data) {
    // const ramList = deployment.ram_data.substring("&lt;ram&gt;".length - 1).split('&lt;ram&gt;');
    const ramList = deployment.ram_data.split('<ram>');

    ramList.forEach(ram => {
      const ramData = fixAndParse(ram);
      arrayRam.push(ramData);
      cumulRamMb = cumulRamMb + Number(ramData.size);
    });
  }
  else if (deployment.ram_text) {
    const ramList = deployment.ram_text.substring("&lt;ram&gt;".length - 1).split('&lt;ram&gt;');

    ramList.forEach(ram => {
      const ramData = fixAndParse(ram);
      arrayRam.push(ramData);
      cumulRamMb = cumulRamMb + Number(ramData.size);
    });
  }


  // // DISK
  let arrayDisk = [];
  if (deployment.disk_data) {
    // const diskList = deployment.disk_data.substring("&lt;disk&gt;".length - 1).split('&lt;disk&gt;');
    const diskList = deployment.disk_data.split('<disk>');

    diskList.forEach(disk => {
      const diskData = fixAndParse(disk);

      if (deployment.extraDiskHealth) {
        const extraDiskHealthList = deployment.extraDiskHealth && deployment.extraDiskHealth.split("<ext_disk>");

        extraDiskHealthList && extraDiskHealthList.forEach(extraDiskHealth => {
          const extraDiskHealthData = fixAndParse(extraDiskHealth);

          const regex = /(?<=ext_disk_health\[)[^\]]*(?=\])/i;
          const items = extraDiskHealthData.xtra_desc.match(regex);

          if (items && items[0] && items[0] == diskData.serial) {
            diskData.extraDiskHealth = extraDiskHealthData.xtra_value;
          }
        });
      }

      if (deployment.extraDiskPerf) {
        const extraDiskPerfList = deployment.extraDiskPerf && deployment.extraDiskPerf.split("<ext_disk>");

        extraDiskPerfList.forEach(extraDiskPerf => {
          const extraDiskPerfData = fixAndParse(extraDiskPerf);

          const regex = /(?<=ext_disk_perf\[)[^\]]*(?=\])/i;
          const items = extraDiskPerfData.xtra_desc.match(regex);

          if (items && items[0] && items[0] == diskData.serial) {
            diskData.extraDiskPerf = extraDiskPerfData.xtra_value;
          }
        });
      }

      arrayDisk.push(diskData);
    });
  }
  else if (deployment.disk_text) {
    const diskList = deployment.disk_text.substring("&lt;disk&gt;".length - 1).split('&lt;disk&gt;');
    diskList.forEach(disk => {
      const diskData = fixAndParse(disk);
      arrayDisk.push(diskData);
    });
  }


  // // STORAGE
  let arrayStorage = [];
  if (deployment.storage_ctrl_data) {
    const storageList = deployment.storage_ctrl_data.split('<storage_ctrl>');

    storageList.forEach(storage => {
      const storageData = fixAndParse(storage);
      arrayStorage.push(storageData);
    });
  }
  else if (deployment.storage_ctrl_text) {
    const storageList = deployment.storage_ctrl_text.substring("&lt;storage_ctrl&gt;".length - 1).split('&lt;storage_ctrl&gt;');

    storageList.forEach(storage => {
      const storageData = fixAndParse(storage);
      arrayStorage.push(storageData);
    });
  }
  // console.log("3346 - arrayStorage=", arrayStorage);

  // // NIC
  let arrayNic = [];
  if (deployment.nic_data) {
    // const nicList = deployment.nic_data.substring("&lt;nic&gt;".length - 1).split('&lt;nic&gt;');
    const nicList = deployment.nic_data.split('<nic>');
    nicList.forEach(nic => {
      const nicData = fixAndParse(nic);

      if (nicData.protocol_version) {
        if (nicData.type === "Wireless") {
          nicData.nicVersionTxt = getWifiVersionText(nicData.protocol_version);
        }
        else if (nicData.type === "Bluetooth") {
          nicData.nicVersionTxt = ' - Bluetooth ' + nicData.protocol_version;
        }
        else {
          nicData.nicVersionTxt = '';
        }
      }
      arrayNic.push(nicData);
    });
  }
  else if (deployment.nic_text) {
    const nicList = deployment.nic_text.substring("&lt;nic&gt;".length - 1).split('&lt;nic&gt;');
    // const nicList = deployment.nic_data.split('<nic>');
    nicList.forEach(nic => {
      const nicData = fixAndParse(nic);
      arrayNic.push(nicData);
    });
  }

  // // CDDVD
  let arrayCddvd = [];
  if (deployment.cddvd_data) {
    const cddvdList = deployment.cddvd_data.split('<cddvd>');
    cddvdList.forEach(cddvd => {
      const cddvdData = fixAndParse(cddvd);
      arrayCddvd.push(cddvdData);
    });
  }
  else if (deployment.cddvd_text) {
    const cddvdList = deployment.cddvd_text.substring("&lt;cddvd&gt;".length - 1).split('&lt;cddvd&gt;');
    cddvdList.forEach(cddvd => {
      const cddvdData = fixAndParse(cddvd);
      arrayCddvd.push(cddvdData);
    });
  }

  // // SOUND
  let arraySound = [];
  if (deployment.sound_data) {
    // const soundList = deployment.sound_data.substring("&lt;sound&gt;".length - 1).split('&lt;sound&gt;');
    const soundList = deployment.sound_data.split('<sound>');
    soundList.forEach(sound => {
      const soundData = fixAndParse(sound);
      arraySound.push(soundData);
    });
  }
  else if (deployment.sound_text) {
    const soundList = deployment.sound_text.substring("&lt;sound&gt;".length - 1).split('&lt;sound&gt;');
    // const soundList = deployment.sound_data.split('<sound>');
    soundList.forEach(sound => {
      const soundData = fixAndParse(sound);
      arraySound.push(soundData);
    });
  }


  // BATTERY
  let arrayBattery = [];
  if (deployment.battery_data) {
    const batteryList = deployment.battery_data.split('<battery>');

    batteryList.forEach(battery => {
      const batteryData = fixAndParse(battery);
      arrayBattery.push(batteryData);
    });
  }
  else if (deployment.battery_text) {
    const batteryList = deployment.battery_text.substring("&lt;battery&gt;".length - 1).split('&lt;battery&gt;');

    batteryList.forEach(battery => {
      const batteryData = fixAndParse(battery);
      arrayBattery.push(batteryData);
    });
  }


  // SCREEN
  let arrayScreen = [];
  if (deployment.screen_data) {
    const screenList = deployment.screen_data.split('<screen>');

    screenList.forEach(screen => {
      const screenData = fixAndParse(screen);
      arrayScreen.push(screenData);
    });
  }
  else if (deployment.screen_text) {
    const screenList = deployment.screen_text.substring("&lt;screen&gt;".length - 1).split('&lt;screen&gt;');

    screenList.forEach(screen => {
      const screenData = fixAndParse(screen);
      arrayScreen.push(screenData);
    });
  }


  // // CDDVD
  let cddvdTxt = "";
  if (deployment.cddvd_data) {
    // const cddvdList = deployment.cddvd_data.substring("&lt;cddvd&gt;".length - 1).split('&lt;cddvd&gt;');
    const cddvdList = deployment.cddvd_data.split('<cddvd>');
    cddvdList.forEach(cddvd => {
      const cddvdData = fixAndParse(cddvd);
      if (cddvdTxt !== "")
        cddvdTxt += " / ";

      cddvdTxt += cddvdData.model;
    });
  }
  else if (deployment.cddvd_text) {
    const cddvdList = deployment.cddvd_text.substring("&lt;cddvd&gt;".length - 1).split('&lt;cddvd&gt;');
    // const cddvdList = deployment.cddvd_text.split('<cddvd>');
    cddvdList.forEach(cddvd => {
      const cddvdData = fixAndParse(cddvd);
      if (cddvdTxt !== "")
        cddvdTxt += " / ";

      cddvdTxt += cddvdData.model;
    });
  }


  // WEBCAM
  let arrayWebcam = [];
  if (deployment.webcam_data) {
    const webcamList = deployment.webcam_data.split('<webcam>');

    webcamList.forEach(webcam => {
      const webcamData = fixAndParse(webcam);
      arrayWebcam.push(webcamData);
    });
  }
  else if (deployment.webcam_text) {
    const webcamList = deployment.webcam_text.substring("&lt;webcam&gt;".length - 1).split('&lt;webcam&gt;');

    webcamList.forEach(webcam => {
      const webcamData = fixAndParse(webcam);
      arrayWebcam.push(webcamData);
    });
  }



  // const cpuTxt = deployment.cpu_manufacturer + " " + deployment.cpu_model + " " + deployment.cpu_frequency;
  // console.log("179 - deployments=", deployments);

  const sorted = deployments.sort(function (a, b) {
    // console.log("2811 -----------------");
    // console.log("2812 - a.date=", new Date(a.date));
    // console.log("2813 - b.date=", new Date(b.date));
    var result = new Date(a.date) == new Date(b.date) ? 0 : new Date(b.date) < new Date(a.date) ? -1 : 1    
    // console.log("2818 - result=", result);
    return result;
  })

  // console.log("3229 - arrayCpu=", arrayCpu);
  // console.log("3229 - arrayRam=", arrayRam);

  let showScreenInfo = false;
  for (const screenData of arrayScreen) {
    if (screenData.size != 0) {
      // console.log("3531 - screenData=", screenData);
      showScreenInfo = true;
  }
  }

  let showOtherInfo = false;
  let textOtherInfo = "";
  for (const webcamData of arrayWebcam) {
    if (webcamData.model !== 'n/a') {
      showOtherInfo = true;
      textOtherInfo = t('history.details.webcam');
    }
  }
  if (deployment.bluetooth) {
    showOtherInfo = true;
    if (textOtherInfo !== "")
      textOtherInfo = textOtherInfo + space + "-" + space;
    textOtherInfo = textOtherInfo + t('history.details.bluetooth')
  }
  if (deployment.biometrics) {
    showOtherInfo = true;
    if (textOtherInfo !== "")
      textOtherInfo = textOtherInfo + space + "-" + space;
    textOtherInfo = textOtherInfo + t('history.details.biometrics')
  }
  if (deployment.cardreader) {
    showOtherInfo = true;
    if (textOtherInfo !== "")
      textOtherInfo = textOtherInfo + space + "-" + space;
    textOtherInfo = textOtherInfo + t('history.details.cardreader')
  }



  return (
    <div>
      <Prompt animated style={{ zIndex: 10000 /* Above tooltip which has 9999 */ }}>
        <div className="prompt__container animated" 
          style={{
            height: "99999px", maxHeight: "90%",
            width: "99999px", maxWidth: "90%",
          }}>

          <PromptWrapper >
            <div className="historyDetails_settings">
              <div className="MuiDataGrid-root" role="grid" aria-colcount={0} aria-rowcount={0}>

                <div className="content__header">
                  <h2>{(t('history.title')) + '\u2000\u2013\u2000'}
                    <span style={{ color: colors.softthinks }}>
                      {deployments.length}
                    </span>
                  </h2>

                  <div className="options">
                    {loaded && (
                      <div className="actions" style={{ gap: '15px' }}>
                        <Button
                          className="button"
                          onClick={toggleAll}
                          startIcon={<span className="material-icons-round">
                            expand_{expanded.length === deployments?.length ? 'less' : 'more'}
                          </span>}
                        >{t('history.deployments.' + (expanded.length === deployments?.length ? 'collapse' : 'expand'))}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="MuiDataGrid-main">

                  <Container
                    lockAxis="y"
                  >
                    <div className={'container ' + (expandedHardwareDetail ? 'open' : 'closed')}>
                      <div className="container__header">
                        <div className="container__title" onClick={() => setExpandedHardwareDetail(!expandedHardwareDetail)}>
                          <span className="material-icons">arrow_{expandedHardwareDetail ? 'drop_down' : 'right'}</span>
                          <h3>{t('history.hardware_details')}</h3>
                        </div>
                      </div>

                      <div className="container__content">
                        <table>
                          <tr >
                            <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 150px 0px 10px' }}>
                              {t('history.details.model')} / {t('history.details.sku')}{t('global.colon')}
                            </th>
                            <td className="td">
                              {deployment.system_manufacturer} {deployment.system_product}{tab}/{tab}{deployment.system_sku}{tab}{deployment.enclosure_chassis ? "(" + deployment.enclosure_chassis + ")" : ""}
                            </td>
                          </tr>

                          <tr></tr>

                          <tr>
                            <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                              {t('history.details.sn')} / {t('history.details.uuid')}
                              {deployment.motherboard_assettag !== "" && deployment.motherboard_assettag !== " " && (
                                <span> / {t('history.details.assettag')}</span>
                              )}
                              {t('global.colon')}
                            </th>
                            <td className="td">
                              {deployment.system_serial}{tab}/{tab}{deployment.system_uuid}
                              {deployment.motherboard_assettag !== "" && deployment.motherboard_assettag !== " " && (
                                <span>{tab}/{tab}{deployment.motherboard_assettag}</span>
                              )}
                            </td>
                          </tr>

                          <tr></tr>
                        {arrayCpu.length === 1 ? (
                            <tr>
                              <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                {t('history.details.processor')}{t('global.colon')}
                              </th>
                              <td className="td">
                                {arrayCpu[0].manufacturer}{space}{arrayCpu[0].model}
                                {arrayCpu[0].nominal_frequency ? tab + Math.round(arrayCpu[0].nominal_frequency / 1000 * 10) / 10 + "GHz" + space + "(up to " + Math.round(arrayCpu[0].max_frequency / 1000 * 10) / 10 + "GHz)" : ""}
                                {arrayCpu[0].cores && arrayCpu[0].cores != '0' ? tab + arrayCpu[0].cores + " cores" : ""}
                              </td>
                            </tr>
                        ) : (
                            <>
                              <tr>
                                <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                  {t('history.details.processor')}{t('global.colon')}
                                </th>
                              {arrayCpu.length} {t('history.details.sockets')}
                              </tr>

                              {
                                arrayCpu.map((cpu, index) => {
                                  if (cpu.manufacturer && cpu.model && cpu.nominal_frequency && cpu.cpuid) {
                                    return <tr>
                                      <td
                                        style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                      >
                                        {/* {t('history.details.socket')} #{index}{t('global.colon')} */}
                                        {cpu.socket} #{index}{t('global.colon')}

                                      </td>
                                      <td className="td">
                                        {cpu.manufacturer}{space}{cpu.model}
                                        {cpu.nominal_frequency ? tab + Math.round(cpu.nominal_frequency / 1000 * 10) / 10 + "GHz" + space + "(up to " + Math.round(cpu.max_frequency / 1000 * 10) / 10 + "GHz)" : ""}
                                        {cpu.cores && cpu.cores != '0' ? tab + cpu.cores + " cores" : ""}
                                      </td>
                                    </tr>
                                  }
                                  else {
                                    return <tr>
                                      <td
                                        style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                      >
                                        {/* {t('history.details.socket')} #{index}{t('global.colon')} */}
                                        {cpu.socket} #{index}{t('global.colon')}
                                      </td>
                                      <td style={{ opacity: '0.4' }}>
                                        {t('history.details.empty')}
                                      </td>
                                    </tr>
                                  }
                                })
                              }
                            </>
                        )}

                          <tr></tr>
                          <tr>
                            <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                              {t('history.details.memory')}{t('global.colon')}
                            </th>
                            <td>
                              {Math.round(cumulRamMb / 1024 * 10) / 10} GB
                            </td>
                          </tr>
                            {
                              arrayRam.map((ram, index) => {
                                if (ram.size != '0') {
                                return <tr>
                                  <td
                                    style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                  >
                                    {t('history.details.bank')} #{index}{t('global.colon')}
                                  </td>
                                  <td className="td">
                                    {Math.round(ram.size / 1024 * 10) / 10} GB
                                    {tab}{ram.type}
                                    {ram.speed && ram.speed > 0 ? tab + ram.speed + "MHz" : ""}
                                    {tab}{t('history.details.rank_' + ram.rank)}
                                    {tab}{ram.form_factor}
                                    {ram.manufacturer ? tab + "(" + ram.manufacturer + ram.part_number + ")" : ""}
                                    {ram.serial ? tab + "[" + ram.serial + "]" : ""}
                                  </td>
                                </tr>
                                }
                                else {
                                return <tr>
                                  <td
                                    style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                  >
                                    {t('history.details.bank')} #{index}{t('global.colon')}
                                  </td>
                                  <td style={{ opacity: '0.4' }}>
                                    {t('history.details.empty')}
                                  </td>
                                </tr>
                                }
                              })
                            }

                          {arrayDisk.length > 0 && (
                            arrayDisk.length === 1 ? (
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.disk')}{t('global.colon')}
                                  </th>
                                  <td className="td">
                                    {(arrayDisk[0].size_commercial).replace(/\s/g, '')}{space}{arrayDisk[0].disk_type}{space}

                                    {arrayDisk[0].rpm > 1 && (
                                      '(' + arrayDisk[0].rpm + 'RPM)' + space
                                    )}

                                    {arrayDisk[0].disk_form_factor != "n/a" && (
                                      (arrayDisk[0].disk_form_factor).replace(/ inches/g, '"') + space
                                    )}

                                    {getDiskBus(arrayDisk[0].bus)}{space}

                                    {arrayDisk[0].manufacturer}{space}{arrayDisk[0].model}{space}[{arrayDisk[0].serial}]

                                    {/* {arrayDisk[0].ppid != "" && ( */}
                                      <span>
                                        {space}-{space}
                                        {t('history.details.ppid')}{t('global.colon')}
                                        {arrayDisk[0].ppid != "" ? arrayDisk[0].ppid : "No PPID"}
                                      </span>
                                    {/* )} */}

                                    {arrayDisk[0].bps && (
                                      <span>
                                        {space}-{space}
                                        {arrayDisk[0].bps}{t('history.details.bps')}
                                      </span>
                                    )}

                                    {arrayDisk[0].remapped_sector && arrayDisk[0].remapped_sector != -1 && (
                                      <span>
                                        {space}-{space}
                                        {t('history.details.remapped_sector')}{t('global.colon')}{arrayDisk[0].remapped_sector}
                                      </span>
                                    )}

                                    {arrayDisk[0].connector && (
                                      <span>
                                        {space}-{space}
                                        {arrayDisk[0].connector}
                                      </span>
                                    )}

                                    {arrayDisk[0].extraDiskHealth && (
                                      <span>
                                        {space}-{space}
                                        {t('history.details.computed_health')}{t('global.colon')}{arrayDisk[0].extraDiskHealth}{" %"}
                                      </span>
                                    )}

                                    {arrayDisk[0].extraDiskPerf && (
                                      <span>
                                        {space}-{space}
                                        {t('history.details.computed_perf')}{t('global.colon')}{arrayDisk[0].extraDiskPerf}{" %"}
                                      </span>
                                    )}

                                    {arrayDisk[0].health && (
                                      <soan>
                                        {space}-{space}
                                    {t('history.details.health')}{t('global.colon')}
                                        <span style={{ color: ((getDiskHealth(arrayDisk[0].health).color !== "") ? getDiskHealth(arrayDisk[0].health).color : "black") }}>{t('history.details.' + getDiskHealth(arrayDisk[0].health).text)}
                                        </span>
                                      </soan>
                                    )}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <>
                          <tr></tr>
                          <tr>
                            <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                              {t('history.details.disk')}{t('global.colon')}
                            </th>
                          </tr>
                          {
                            arrayDisk.map((disk, index) => {
                              return <tr>
                                <td
                                  style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                >
                                  {t('history.details.disk')} #{index}{t('global.colon')}
                                </td>
                                      <td className="td">
                                        {(disk.size_commercial).replace(/\s/g, '')}{space}{disk.disk_type}{space}

                                        {disk.rpm > 1 && (
                                          '(' + disk.rpm + 'RPM)' + space
                                        )}

                                        {disk.disk_form_factor != "n/a" && (
                                          (disk.disk_form_factor).replace(/ inches/g, '"') + space
                                        )}

                                        {getDiskBus(disk.bus)}{space}

                                        {disk.manufacturer}{space}{disk.model}{space}[{disk.serial}]

                                        {/* {disk.ppid != "" && ( */}
                                          <span>
                                            {space}-{space}
                                            {t('history.details.ppid')}{t('global.colon')}
                                            {disk.ppid != "" ? disk.ppid : "No PPID"}
                                          </span>
                                        {/* )} */}

                                        {disk.bps != "" && (
                                          <span>
                                            {space}-{space}
                                            {disk.bps}{t('history.details.bps')}
                                          </span>
                                        )}

                                        {disk.remapped_sector != -1 && (
                                          <span>
                                            {space}-{space}
                                            {t('history.details.remapped_sector')}{t('global.colon')}{disk.remapped_sector}
                                          </span>
                                        )}
                                        {disk.extraDiskHealth && (
                                          <span>
                                            {space}-{space}
                                            {disk.connector}
                                          </span>
                                        )}

                                        {disk.extraDiskHealth && (
                                          <span>
                                            {space}-{space}
                                            {t('history.details.computed_health')}{t('global.colon')}{disk.extraDiskHealth}{" %"}
                                          </span>
                                        )}

                                        {disk.extraDiskPerf && (
                                          <span>
                                            {space}-{space}
                                            {t('history.details.computed_perf')}{t('global.colon')}{disk.extraDiskPerf}{" %"}
                                          </span>
                                        )}

                                        {disk.health && (
                                          <span>
                                            {space}-{space}
                                        {t('history.details.health')}{t('global.colon')}
                                        <span style={{ color: ((getDiskHealth(disk.health).color !== "") ? getDiskHealth(disk.health).color : "black") }}>{t('history.details.' + getDiskHealth(disk.health).text)}</span>
                                          </span>
                                        )}
                                </td>
                              </tr>
                            })
                          }
                              </>
                            )
                          )}

                          {arrayStorage.length > 0 && (
                            arrayStorage.length === 1 ? (
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.controller')}{t('global.colon')}
                                  </th>
                                  <td className="td">
                                    {arrayStorage[0].manufacturer}{space}{arrayStorage[0].model}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.controller')}{t('global.colon')}
                                  </th>
                                </tr>
                                {
                                  arrayStorage.map((storage, index) => {
                                    return <tr>
                                      <td
                                        style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                      >
                                        {t('history.details.controller')} #{index}{t('global.colon')}
                                      </td>
                                      <td className="td">
                                        {storage.manufacturer}{space}{storage.model}
                                </td>
                              </tr>
                            })
                          }
                              </>
                            )
                          )}

                          {arrayGpu.length > 0 && (
                            arrayGpu.length === 1 ? (
                              
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.graphics_card')}{t('global.colon')}
                                  </th>
                                  <td className="td">
                                    {/* {arrayGpu[0].model}
                                    {arrayGpu[0].cores ? space + '(' + arrayGpu[0].cores + ' cores)' : ""} */}

                                    {arrayGpu[0].pnp.startsWith("PCI\\VEN_8086&") ? "Intel " : ""}
                                    {arrayGpu[0].pnp.startsWith("PCI\\VEN_10DE&") ? "NVIDIA " : ""}
                                    {arrayGpu[0].pnp.startsWith("PCI\\VEN_1002&") ? "AMD " : ""}
                                    {arrayGpu[0].model ? arrayGpu[0].model + " " : ""}
                                    {arrayGpu[0].die_name ? arrayGpu[0].die_name + " " : ""}

                                    {arrayGpu[0].cores && arrayGpu[0].cores > 0 ? (
                                      (arrayGpu[0].pnp.startsWith("PCI\\VEN_8086&") ? arrayGpu[0].cores + " shaders (" + arrayGpu[0].cores / 8 + " Executions units) " : "") +
                                      (arrayGpu[0].pnp.startsWith("PCI\\VEN_10DE&") ? arrayGpu[0].cores + " CUDA cores " : "") +
                                      (arrayGpu[0].pnp.startsWith("PCI\\VEN_1002&") ? arrayGpu[0].cores + " shaders " : "") +
                                      (
                                        (arrayGpu[0].pnp.startsWith("PCI\\VEN_8086&") || arrayGpu[0].pnp.startsWith("PCI\\VEN_10DE&") || arrayGpu[0].pnp.startsWith("PCI\\VEN_1002&")) ?
                                          "" : arrayGpu[0].cores + " cores "
                                      )
                                    ) : ""
                                    }

                                    {(arrayGpu[0].ram && arrayGpu[0].ram > 0) ? "- memory: " + arrayGpu[0].ram + " MB allocated " : ""}
                                    {(arrayGpu[0].ram_bus_width && arrayGpu[0].ram_bus_width > 0) ? "bus: " + arrayGpu[0].ram_bus_width + " bits" : ""}

                                  </td>
                                </tr>
                              </>

                            ) : (

                              <>
                          <tr></tr>
                          <tr>
                            <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                              {t('history.details.graphics_card')}{t('global.colon')}
                            </th>
                          </tr>
                          {
                            arrayGpu.map((gpu, index) => {
                              return <tr>
                                <td
                                  style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                >
                                  {t('history.details.graphics_card')} #{index}{t('global.colon')}
                                </td>
                                      <td className="td">
                                        {/* {gpu.model}
                                        {gpu.cores ? space + '(' + gpu.cores + ' cores)' : ""} */}

                                        {gpu.pnp.startsWith("PCI\\VEN_8086&") ? "Intel " : ""}
                                        {gpu.pnp.startsWith("PCI\\VEN_10DE&") ? "NVIDIA " : ""}
                                        {gpu.pnp.startsWith("PCI\\VEN_1002&") ? "AMD " : ""}
                                        {gpu.model ? gpu.model + " " : ""}
                                        {gpu.die_name ? gpu.die_name + " " : ""}

                                        {gpu.cores && gpu.cores > 0 ? (
                                          (gpu.pnp.startsWith("PCI\\VEN_8086&") ? gpu.cores + " shaders (" + gpu.cores / 8 + " Executions units) " : "") +
                                          (gpu.pnp.startsWith("PCI\\VEN_10DE&") ? gpu.cores + " CUDA cores " : "") +
                                          (gpu.pnp.startsWith("PCI\\VEN_1002&") ? gpu.cores + " shaders " : "") +
                                          (
                                            (gpu.pnp.startsWith("PCI\\VEN_8086&") || gpu.pnp.startsWith("PCI\\VEN_10DE&") || gpu.pnp.startsWith("PCI\\VEN_1002&")) ?
                                              "" : gpu.cores + " cores "
                                          )
                                        ) : ""
                                        }

                                        {(gpu.ram && gpu.ram > 0) ? "- memory: " + gpu.ram + " MB allocated " : ""}
                                        {(gpu.ram_bus_width && gpu.ram_bus_width > 0) ? "bus: " + gpu.ram_bus_width + " bits" : ""}

                                </td>
                              </tr>
                            })
                          }
                              </>
                            )
                          )}

                          {arraySound.length > 0 && (
                            arraySound.length === 1 ? (
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.sound_card')}{t('global.colon')}
                                  </th>
                                  <td className="td">
                                    {arraySound[0].model}
                                  </td>
                                </tr>
                              </>
                            ) : (
                            <>
                              <tr></tr>
                              <tr>
                                <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                  {t('history.details.sound_card')}{t('global.colon')}
                                </th>
                              </tr>
                          {
                            arraySound.map((sound, index) => {
                                  return <tr>
                                    <td
                                      style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                    >
                                      {t('history.details.sound_card')} #{index}{t('global.colon')}
                                    </td>
                                      <td className="td">
                                      {sound.model}
                                    </td>
                                  </tr>
                            })
                          }
                            </>
                            )
                          )}

                          {arrayNic.length > 0 && (
                            arrayNic.length === 1 ? (
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.network_adapter')}{t('global.colon')}
                                  </th>
                                  <td className="td">
                                    {arrayNic[0].type}{space}-{space}{arrayNic[0].model}{space}{arrayNic[0].connection_speed !== '0' ? arrayNic[0].connection_speed + 'Mbps' + space : ''}({arrayNic[0].mac}) {arrayNic[0].nicVersionTxt}
                                  </td>
                                </tr>
                              </>
                            ) : (
                            <>
                              <tr></tr>
                              <tr>
                                <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                  {t('history.details.network_adapter')}{t('global.colon')}
                                </th>
                              </tr>

                          {
                            arrayNic.map((nic, index) => {
                                  return <tr>
                                    <td
                                      style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                    >
                                      {t('history.details.network_adapter')} #{index}{t('global.colon')}
                                    </td>
                                      <td className="td">
                                        {nic.type}{space}-{space}{nic.model}{space}{nic.connection_speed !== '0' ? nic.connection_speed + 'Mbps' + space : ''}({nic.mac}) {nic.nicVersionTxt}
                                      </td>
                                    </tr>
                                  })
                                }
                              </>
                            )
                          )}

                          {arrayCddvd.length > 0 && (
                            arrayCddvd.length === 1 ? (
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.optical_drive')}{t('global.colon')}
                                  </th>
                                  <td className="td">
                                    {arrayCddvd[0].manufacturer}{space}{arrayCddvd[0].model}{space}{arrayCddvd[0].media}{space}({arrayCddvd[0].firmware})
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.optical_drive')}{t('global.colon')}
                                  </th>
                                </tr>

                                {
                                  arrayCddvd.map((cddvd, index) => {
                                    return <tr>
                                      <td
                                        style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                      >
                                        {t('history.details.optical_drive')} #{index}{t('global.colon')}
                                      </td>
                                      <td className="td">
                                        {cddvd.manufacturer}{space}{cddvd.model}{space}({cddvd.media}{space}({cddvd.firmware}))
                                    </td>
                                  </tr>
                            })
                          }
                            </>
                            )
                          )}

                          < tr ></tr>
                          <tr >
                            <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 150px 0px 10px' }}>
                              {t('history.details.motherboard')}{t('global.colon')}
                            </th>
                            <td>
                              {deployment.motherboard_manufacturer}{space}{deployment.motherboard_model}{space}[{deployment.motherboard_serial}]{space}-{space}{t('history.details.version')}{t('global.colon')}{deployment.motherboard_version}
                            </td>
                          </tr>

                          <tr></tr>
                          <tr >
                            <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 150px 0px 10px' }}>
                              {t('history.details.bios')}{t('global.colon')}
                            </th>
                            <td>
                              {deployment.bios_vendor}{space}-{space}{t('history.details.version')}{t('global.colon')}{deployment.bios_version}{space}-{space}{t('history.details.date')}{t('global.colon')}{deployment.bios_date}

                              {deployment.tpm_version && (
                                <span>
                                  - {t('history.details.tpm_version')}{t('global.colon')}{deployment.tpm_version}
                                </span>
                              )}

                            </td>
                          </tr>


                          {arrayBattery.length > 0 && (
                            arrayBattery.length === 1 ? (
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.battery')}{t('global.colon')}
                                  </th>
                                  <td>
                                    {arrayBattery[0].chemistry}{space}{arrayBattery[0].vendor}{space}{arrayBattery[0].name}{space}[{arrayBattery[0].serial}]{space}-{space}
                                    {t('history.details.battery_health')}{t('global.colon')} {100 - Number(arrayBattery[0].wear_level) + " %"}{space}
                                    ({arrayBattery[0].fullcharged_cap}mWH of {arrayBattery[0].designed_cap}mWH{space}-{space}
                                    {arrayBattery[0].cyclecount}{space}cycles)
                                  </td>
                                </tr>
                              </>
                            ) : (
                            <>
                              <tr></tr>
                              <tr>
                                <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                  {t('history.details.battery')}{t('global.colon')}
                                </th>
                              </tr>

                          {
                            arrayBattery.map((battery, index) => {
                                  return <tr>
                                    <td
                                      style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                    >
                                      {t('history.details.battery')} #{index}{t('global.colon')}
                                    </td>
                                    <td>
                                        {battery.chemistry}{space}{battery.vendor}{space}{battery.name}{space}[{battery.serial}]{space}-{space}
                                        {t('history.details.battery_health')}{t('global.colon')} {100 - Number(battery.wear_level) + " %"}{space}
                                        ({battery.fullcharged_cap}mWH of {battery.designed_cap}mWH{space}-{space}
                                        {battery.cyclecount}{space}cycles)

                                    </td>
                                  </tr>
                            })
                          }
                            </>
                            )
                          )}

                          {showScreenInfo && arrayScreen.length > 0 && (
                            arrayScreen.length === 1 ? (
                              <>
                                <tr></tr>
                                <tr>
                                  <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                    {t('history.details.screen')}{t('global.colon')}
                                  </th>
                                  <td>
                                    {isNaN(arrayScreen[0].size) ? arrayScreen[0].size : arrayScreen[0].size + '"'}{space}
                                    ({arrayScreen[0].max_resol_x + ' x ' + arrayScreen[0].max_resol_y}){space}
                                    {arrayScreen[0].touch == '1' ? t('history.details.screen_touch') + space : ''}
                                    {arrayScreen[0].vendor != 'n/a' ? arrayScreen[0].vendor + space : ''}
                                    {arrayScreen[0].model != 'n/a' ? arrayScreen[0].model + space : ''}
                                    {arrayScreen[0].serial != 'n/a' ? '[' + arrayScreen[0].serial + ']' : ''}
                                  </td>
                                </tr>
                              </>
                            ) : (
                            <>
                              <tr></tr>
                              <tr>
                                <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 50px 0px 10px' }}>
                                  {t('history.details.screen')}{t('global.colon')}
                                </th>
                              </tr>

                          {
                            arrayScreen.map((screen, index) => {
                                  return <tr>
                                    <td
                                      style={{ padding: '0px 20px 0px 10px', textAlign: 'end' }}
                                    >
                                      {t('history.details.screen')} #{index}{t('global.colon')}
                                    </td>
                                    <td>
                                        {isNaN(screen.size) ? screen.size : screen.size + '"'}{space}
                                        ({screen.max_resol_x + ' x ' + screen.max_resol_y}){space}
                                        {screen.touch == '1' ? t('history.details.screen_touch') + space : ''}
                                        {screen.vendor != 'n/a' ? screen.vendor + space : ''}
                                        {screen.model != 'n/a' ? screen.model + space : ''}
                                        {screen.serial != 'n/a' ? '[' + screen.serial + ']' : ''}
                                    </td>
                                  </tr>
                            })
                          }
                            </>
                            )
                          )}

                          {showOtherInfo && (
                            <>
                              <tr></tr>
                              <tr >
                                <th style={{ margin: '5px', fontSize: '15px', textAlign: 'start', fontWeight: '600', color: 'rgb(var(--accent-color))', padding: '0px 150px 0px 10px' }}>
                                  {t('history.details.other')}{t('global.colon')}
                                </th>
                                <td>
                                  {textOtherInfo}
                                </td>
                              </tr>
                            </>
                        )}
                        </table>
                      </div>
                    </div>
                  </Container>

                  <hr style={{ margin: '1px auto', width: '80%' }} />

                  {deployments.length > 0 ? ( // a.private = (false || true), global scenarios are first in alphabetical order

                    <div>
                      {
                        sorted.map((deploymentElement, key) => {

                          if (deploymentElement.modules.length === 0) {
                            return <div></div>
                          }
                          return (
                            <Deployment
                              selected={deployment.deployment_id}
                              deployment={deploymentElement}
                              expanded={expanded}
                              setExpanded={setExpanded}
                              extraDiskHealth={deployment.extraDiskHealth}
                              extraDiskPerf={deployment.extraDiskPerf}
                            />
                          )
                        }
                        )}
                    </div>
                  ) : ( // Scenarios are empty or no location is selected
                    <div className="loader">
                      {loaded ? <h2>{t('reporting.no_data')}.</h2> : <BeatLoader color={colors.softthinks} />}
                    </div>
                  )}
                </div>

              </div>
            </div>
          </PromptWrapper >

          <PromptActions column>
            <Button className="btnSecondary" style={{ margin: '1px auto', width: '50%' }} onClick={() => setDeployment(null)}>
              {t('global.close')}
            </Button>
          </PromptActions>
        </div>
      </Prompt>
    </div>
  );
}
